module.exports = __webpack_public_path__ + "img/01db616.png";